var isBlank = require('./isBlank');
var trim = require('./trim');

module.exports = function words(str, delimiter) {
  if (isBlank(str)) return [];
  return trim(str, delimiter).split(delimiter || /\s+/);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/words.js
// module id = F2/g
// module chunks = 0